import React, { useState } from "react";
import {
  Box,
  useTheme,
  FormControl,
  Select,
  MenuItem,
  TextField,
  Autocomplete,
  TextareaAutosize,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormHelperText,
  Grid,
} from "@mui/material";
import { Typography } from "../../../common/Typography/Typography";
import { Button } from "../../../common/Button/Button";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import { Formik } from "formik";
import * as Yup from "yup";
import { useMutation } from "@apollo/client";
import { CreateDestinationDocument, DestinationType } from "../../../generated";
import { useParams } from "react-router-dom";
import { CustomTextArea } from "../../../common/CustomTextArea/CustomTextArea";
import { CustomTextField } from "../../../common/CustomTextField/CustomTextField";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { toast } from "react-toastify";
import { MethodForm } from "./MethodForm";
export const DestinationForm = ({
  values,
  handleChange,
  handleSubmit,
  errors,
  touched,
  toggleRightSidePanel,
  showToast,
  disabled,
}: {
  values: any;
  touched: any;
  handleChange: any;
  handleSubmit: Function;
  errors: any;
  toggleRightSidePanel?: any;
  showToast?: any;
  disabled: any;
}) => {
  const { palette } = useTheme();

  console.log(values);

  return (
    <Box
      boxSizing="border-box"
      sx={{
        minHeight: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
      }}
    >
      <Box>
        <Box
          sx={{
            paddingRight: "20px",
            paddingBottom: "16px",
            borderBottom: `1px solid ${palette.outline}`,
          }}
          mb={6}
        >
          <Typography
            mb={2}
            variant="h5"
            color={palette.gray.dark}
            sx={{
              fontSize: "12px",
              lineHeight: "14px",
              textTransform: "uppercase",
              fontWeight: "700",
            }}
          >
            DESTINATION
          </Typography>
          <Typography
            mb={4}
            variant="h5"
            color={palette.common.black}
            sx={{ wordBreak: "break-word" }}
          >
            New Destination
          </Typography>
        </Box>
        <Box boxSizing="border-box">
          <Box mb={6}>
            <Typography
              mb={2}
              variant="h6"
              color={palette.common.black}
              sx={{ fontWeight: "400" }}
            >
              Destination Access Method
            </Typography>
            <Box
              mb={3}
              display="flex"
              flexDirection="column"
              sx={{
                ".MuiFormControlLabel-root": {
                  alignItems: "flex-start",
                  margin: "0 0 12px -16px",
                },
                ".MuiRadio-root": {
                  paddingTop: "0",
                },
                ".Mui-checked + span .label-title": {
                  fontWeight: 500,
                },
              }}
            >
              <FormControl>
                <Typography
                  variant="body1"
                  mb={2}
                  fontSize="0.875rem"
                  fontWeight={500}
                  color={palette.common.black}
                >
                  Method
                </Typography>
                <RadioGroup
                  defaultValue="newDestiantion"
                  name="method"
                  value={values.method}
                  onChange={handleChange}
                >
                  <FormHelperText
                    style={{
                      color: palette.error.dark,
                      fontFamily: "Roboto",
                      fontSize: "14px",
                      lineHeight: "20px",
                      fontWeight: 400,
                    }}
                  >
                    {errors.method}
                  </FormHelperText>
                  <FormControlLabel
                    value={DestinationType.Download}
                    control={<Radio />}
                    label={
                      <>
                        <Typography
                          variant="body1"
                          mb={2}
                          fontSize="1rem"
                          lineHeight="1"
                          fontWeight={400}
                          className="label-title"
                          color={palette.common.black}
                        >
                          Download
                        </Typography>
                        <Typography
                          variant="body1"
                          fontSize="0.875rem"
                          lineHeight="1.2"
                          fontWeight={400}
                          color={palette.gray.darkest}
                        >
                          Export the data product as a .csv or .json file
                        </Typography>
                      </>
                    }
                  />
                  <FormControlLabel
                    value={DestinationType.Connect}
                    control={<Radio />}
                    label={
                      <>
                        <Typography
                          variant="body1"
                          mb={2}
                          fontSize="1rem"
                          lineHeight="1"
                          fontWeight={400}
                          className="label-title"
                          color={palette.common.black}
                        >
                          Connect Destination
                        </Typography>
                        <Typography
                          variant="body1"
                          fontSize="0.875rem"
                          lineHeight="1.2"
                          fontWeight={400}
                          color={palette.gray.darkest}
                        >
                          Choose from a list of supported destinations
                        </Typography>
                      </>
                    }
                  />
                  <FormControlLabel
                    value={DestinationType.Api}
                    control={<Radio />}
                    label={
                      <>
                        <Typography
                          variant="body1"
                          mb={2}
                          fontSize="1rem"
                          lineHeight="1"
                          fontWeight={400}
                          className="label-title"
                          color={palette.common.black}
                        >
                          API connect
                        </Typography>
                        <Typography
                          variant="body1"
                          fontSize="0.875rem"
                          lineHeight="1.2"
                          fontWeight={400}
                          color={palette.gray.darkest}
                        >
                          Get a URL endpoint to use in your applications
                        </Typography>
                      </>
                    }
                  />
                </RadioGroup>
              </FormControl>
            </Box>

            <MethodForm
              values={values}
              handleChange={handleChange}
              errors={errors}
              touched={touched}
            />

            <Box
              sx={{
                paddingTop: "20px",
                paddingRight: "20px",
                paddingBottom: "16px",
                borderBottom: `1px solid ${palette.outline}`,
              }}
              mb={6}
            >
              <Typography
                mb={2}
                variant="h6"
                color={palette.common.black}
                sx={{ fontWeight: "400" }}
              >
                About
              </Typography>
              <Box mb={6} display="flex" flexDirection="column">
                <Typography
                  variant="body1"
                  mb={2}
                  fontSize="0.875rem"
                  fontWeight={500}
                  color={palette.common.black}
                >
                  Destination Name
                </Typography>

                <CustomTextField
                  name="name"
                  value={values.name}
                  onChange={handleChange}
                  error={errors.name}
                  touched={touched.name}
                />
              </Box>
              <Box mb={6} display="flex" flexDirection="column">
                <Typography
                  variant="body1"
                  mb={2}
                  fontSize="0.875rem"
                  fontWeight={500}
                  color={palette.common.black}
                >
                  Destination Description
                </Typography>

                <CustomTextArea
                  name="description"
                  value={values.description}
                  onChange={handleChange}
                  error={errors.description}
                  touched={touched.description}
                />
              </Box>
            </Box>

            {/* {show && (
                <>
                  <Box
                    mb={4}
                    sx={{
                      background: palette.settings.lighter,
                      borderRadius: "4px",
                      padding: "20px",
                    }}
                  >
                    <Box
                      sx={{
                        ".MuiFormControlLabel-root": {
                          alignItems: "flex-start",
                          margin: "0 0 12px -16px",
                        },
                        ".MuiRadio-root": {
                          paddingTop: "0",
                        },
                        ".label-title": {
                          marginTop: "2px",
                        },
                        ".Mui-checked + span .label-title": {
                          fontWeight: 500,
                        },
                      }}
                    >
                      <FormControl>
                        <Typography
                          variant="body1"
                          mb={2}
                          fontSize="0.875rem"
                          fontWeight={500}
                          color={palette.common.black}
                        >
                          File format
                        </Typography>
                        <RadioGroup
                          defaultValue="csv"
                          name="format"
                          onChange={handleChange}
                          value={values.format}
                        >
                          <FormControlLabel
                            value="csv"
                            control={<Radio />}
                            label={
                              <>
                                <Typography
                                  variant="body1"
                                  mb={2}
                                  fontSize="1rem"
                                  lineHeight="1"
                                  fontWeight={400}
                                  className="label-title"
                                  color={palette.common.black}
                                >
                                  .csv
                                </Typography>
                              </>
                            }
                          />
                          <FormControlLabel
                            value="json"
                            control={<Radio />}
                            label={
                              <>
                                <Typography
                                  variant="body1"
                                  mb={2}
                                  fontSize="1rem"
                                  lineHeight="1"
                                  fontWeight={400}
                                  className="label-title"
                                  color={palette.common.black}
                                >
                                  .json
                                </Typography>
                              </>
                            }
                          />
                        </RadioGroup>
                      </FormControl>
                    </Box>
                  </Box>

                  <Box
                    display="flex"
                    flexDirection="column"
                    mb={4}
                    sx={{
                      background: palette.settings.lighter,
                      borderRadius: "4px",
                      padding: "20px",
                    }}
                  >
                    <Typography
                      variant="body1"
                      mb={2}
                      fontSize="0.875rem"
                      fontWeight={500}
                      color={palette.common.black}
                    >
                      Destination
                    </Typography>
                    <FormControl fullWidth>
                      <Select
                        labelId="demo-simple-select-label"
                        name="template"
                        value={values.template}
                        id="demo-simple-select"
                        label="Owner"
                        onChange={handleChange}
                        sx={{
                          fieldset: {
                            top: "0",
                          },
                          legend: {
                            display: "none",
                          },
                          ".MuiInputBase-input": {
                            width: "100%",
                            height: "36px",
                            fontSize: "16px",
                            lineHeight: "20px",
                            padding: "8px",
                            boxSizing: "border-box",
                            background: palette.common.white,
                          },
                        }}
                      >
                        <MenuItem value="id">Template</MenuItem>
                        <MenuItem value="id">Template 1</MenuItem>
                        <MenuItem value="id">Template 2</MenuItem>
                      </Select>
                    </FormControl>
                  </Box>

                  <Box
                    mb={4}
                    sx={{
                      background: palette.settings.lighter,
                      borderRadius: "4px",
                      padding: "20px",
                    }}
                  >
                    <Box mb={3}>
                      <Typography
                        variant="body1"
                        mb={2}
                        fontSize="0.875rem"
                        fontWeight={500}
                        color={palette.common.black}
                      >
                        Category label
                      </Typography>
                      <TextField
                        sx={{
                          width: "100%",
                          mb: 3,
                          ".MuiInputBase-input": {
                            width: "100%",
                            height: "36px",
                            fontSize: "16px",
                            lineHeight: "20px",
                            padding: "8px",
                            boxSizing: "border-box",
                            background: palette.common.white,
                          },
                        }}
                        name="category"
                        value={values.category}
                        onChange={handleChange}
                      />
                    </Box>
                    <Box mb={4}>
                      <Typography
                        variant="body1"
                        mb={1}
                        fontSize="0.875rem"
                        fontWeight={400}
                        color={palette.common.black}
                      >
                        Account
                      </Typography>
                      <Box sx={{ position: "relative" }}>
                        <Button
                          color="grayAccent"
                          variant="outlined"
                          sx={{
                            position: "absolute",
                            left: "7px",
                            top: "17px",
                            border: "none !important",
                            boxShadow: "none !important",
                            padding: "0 !important",
                            pointerEvents: "none",
                            minWidth: "inherit",
                          }}
                        >
                          <svg
                            width="21"
                            height="21"
                            viewBox="0 0 21 21"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M10.2961 0.217529C8.35293 0.221218 6.45273 0.789431 4.82698 1.85296C3.20124 2.91648 1.92013 4.42942 1.13969 6.20749C0.359255 7.98556 0.113177 9.95201 0.431432 11.8673C0.749686 13.7826 1.61854 15.5642 2.93216 16.9949C3.87036 18.011 5.00904 18.8219 6.27645 19.3765C7.54385 19.9312 8.9125 20.2175 10.2961 20.2175C11.6798 20.2175 13.0484 19.9312 14.3158 19.3765C15.5832 18.8219 16.7219 18.011 17.6601 16.9949C18.9737 15.5642 19.8426 13.7826 20.1609 11.8673C20.4791 9.95201 20.233 7.98556 19.4526 6.20749C18.6722 4.42942 17.391 2.91648 15.7653 1.85296C14.1396 0.789431 12.2394 0.221218 10.2961 0.217529ZM10.2961 18.2362C8.22067 18.233 6.22733 17.4256 4.73558 15.9838C5.18848 14.8822 5.95894 13.94 6.94904 13.2769C7.93914 12.6138 9.10419 12.2598 10.2961 12.2598C11.4881 12.2598 12.6531 12.6138 13.6432 13.2769C14.6333 13.94 15.4038 14.8822 15.8567 15.9838C14.365 17.4256 12.3716 18.233 10.2961 18.2362ZM8.29234 8.22581C8.29234 7.82983 8.40986 7.44275 8.63004 7.11352C8.85022 6.78428 9.16317 6.52767 9.52932 6.37614C9.89547 6.2246 10.2984 6.18496 10.6871 6.26221C11.0758 6.33946 11.4328 6.53014 11.713 6.81013C11.9933 7.09012 12.1841 7.44686 12.2614 7.83522C12.3388 8.22359 12.2991 8.62613 12.1474 8.99196C11.9958 9.35779 11.7389 9.67048 11.4094 9.89047C11.0799 10.1105 10.6925 10.2279 10.2961 10.2279C9.7647 10.2279 9.25502 10.0169 8.87924 9.64148C8.50345 9.26602 8.29234 8.75679 8.29234 8.22581ZM17.2193 14.232C16.3241 12.7022 14.9464 11.5122 13.3019 10.8485C13.812 10.2706 14.1444 9.55784 14.2591 8.79583C14.3739 8.03382 14.2662 7.25492 13.9488 6.55257C13.6315 5.85023 13.1181 5.25429 12.4702 4.83627C11.8223 4.41824 11.0674 4.19589 10.2961 4.19589C9.52489 4.19589 8.77001 4.41824 8.12211 4.83627C7.4742 5.25429 6.96078 5.85023 6.64345 6.55257C6.32613 7.25492 6.21838 8.03382 6.33314 8.79583C6.44791 9.55784 6.7803 10.2706 7.29043 10.8485C5.64591 11.5122 4.26816 12.7022 3.37299 14.232C2.65958 13.0179 2.28264 11.6358 2.28092 10.2279C2.28092 8.10395 3.12538 6.06701 4.62852 4.56517C6.13167 3.06333 8.17037 2.2196 10.2961 2.2196C12.4219 2.2196 14.4606 3.06333 15.9638 4.56517C17.4669 6.06701 18.3114 8.10395 18.3114 10.2279C18.3096 11.6358 17.9327 13.0179 17.2193 14.232Z"
                              fill={palette.grayAccent.light}
                            />
                          </svg>
                        </Button>
                        <Autocomplete
                          id="account-name"
                          freeSolo
                          defaultValue={"account_name" || []}
                          onChange={(_, value) => { }}
                          options={["Template1, Template2, Template3"] || []}
                          renderInput={(params) => <TextField {...params} />}
                          sx={{
                            width: "100%",
                            background: palette.common.white,
                            ".MuiInputBase-input": {
                              width: "100%",
                              height: "36px",
                              fontSize: "16px",
                              lineHeight: "20px",
                              padding: "8px",
                              paddingLeft: "30px !important",
                              boxSizing: "border-box",
                            },
                          }}
                        />
                      </Box>
                    </Box>
                    <Box>
                      <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <Typography
                          variant="body1"
                          mb={2}
                          fontSize="0.875rem"
                          fontWeight={500}
                          color={palette.common.black}
                        >
                          URL to view data
                        </Typography>
                        <Typography
                          variant="body1"
                          mb={2}
                          fontSize="12px"
                          fontWeight={400}
                          color={palette.gray.dark}
                        >
                          Optional
                        </Typography>
                      </Box>
                      <TextField
                        sx={{
                          width: "100%",
                          mb: 3,
                          ".MuiInputBase-input": {
                            width: "100%",
                            height: "36px",
                            fontSize: "16px",
                            lineHeight: "20px",
                            padding: "8px",
                            boxSizing: "border-box",
                            background: palette.common.white,
                          },
                        }}
                        name="viewURL"
                        value={values.viewURL}
                        type="url"
                        onChange={handleChange}
                      />
                    </Box>
                  </Box>

                  <Box
                    mb={4}
                    sx={{
                      background: palette.settings.lighter,
                      borderRadius: "4px",
                      padding: "20px",
                    }}
                  >
                    <Box sx={{ position: "relative" }}>
                      <Typography
                        variant="body1"
                        mb={2}
                        fontSize="0.875rem"
                        fontWeight={500}
                        color={palette.common.black}
                      >
                        API endpoint URL
                      </Typography>
                      <TextField
                        sx={{
                          width: "100%",
                          mb: 3,
                          ".MuiInputBase-input": {
                            width: "100%",
                            height: "36px",
                            fontSize: "16px",
                            lineHeight: "20px",
                            padding: "8px",
                            boxSizing: "border-box",
                            background: palette.common.white,
                          },
                        }}
                        name="apiURL"
                        value={values.apiURL}
                        type="url"
                        onChange={handleChange}
                      />
                      <Box>
                        <Button
                          color="grayAccent"
                          variant="contained"
                          sx={{ marginBottom: "10px" }}
                          onClick={() => { }}
                        >
                          <ContentCopyOutlinedIcon
                            sx={{ fontSize: "16px", marginRight: "3px" }}
                          />
                          Copy
                        </Button>
                      </Box>
                      <Typography
                        variant="body1"
                        mb={1}
                        fontSize="0.875rem"
                        fontWeight={400}
                        color={palette.gray.darkest}
                      >
                        Use this URL connect your applications to destination data.
                      </Typography>
                    </Box>
                  </Box>
                </>
              )} */}

            {/* <Box
              mb={4}
              sx={{
                background: palette.settings.lighter,
                borderRadius: "4px",
                padding: "20px",
              }}
            >
              <Box sx={{ position: "relative" }}>
                <Typography
                  variant="body1"
                  mb={2}
                  fontSize="0.875rem"
                  fontWeight={500}
                  color={palette.common.black}
                >
                  Workspace Airbyte Instance Destination URL
                </Typography>
                <CustomTextField
                  name="destinationURL"
                  value={values.destinationURL}
                  type="url"
                  error={errors.destinationURL}
                  touched={touched.destinationURL}
                  onChange={handleChange}
                  showErrorText={false}
                />

                {touched.destinationURL && errors.destinationURL && (
                  <Grid container direction="row" style={{ marginTop: "5px" }}>
                    <Grid item xs={1}>
                      <ErrorOutlineIcon color="error" />
                    </Grid>
                    <Grid item xs={11}>
                      <Typography
                        variant="body1"
                        mb={1}
                        fontSize="14px"
                        fontWeight={400}
                        lineHeight="20px"
                        letterSpacing="0.0025em"
                        color={palette.common.black}
                      >
                        This field is required. If you don’t know the URL or
                        have issues accessing your hosted airbyte, please
                        contact your Brighthive rep
                      </Typography>
                    </Grid>
                  </Grid>
                )}
              </Box>
            </Box> */}
          </Box>
        </Box>
      </Box>
      <Box>
        <Button
          color="primary"
          variant="contained"
          sx={{ width: "100%", marginBottom: "10px" }}
          onClick={(e) => handleSubmit()}
        >
          Save
        </Button>
        <Button
          color="grayAccent"
          variant="outlined"
          sx={{ width: "100%" }}
          onClick={toggleRightSidePanel}
          disabled
        >
          Cancel
        </Button>
      </Box>
    </Box>
  );
};
